import { useContext, createContext, useState, Dispatch, SetStateAction } from 'react';
import ItemDto from '../models/ItemDto';

interface ItemContextInterface {
  item: ItemDto | undefined;
  setItem: Dispatch<SetStateAction<ItemDto | undefined>>;
}

const ItemContext = createContext<ItemContextInterface>({ item: undefined, setItem: () => { } });

export const useItemContext = () => useContext(ItemContext);

export function ItemContextProvider(props: React.PropsWithChildren<{}>) {
  const [item, setItem] = useState<ItemDto | undefined>(undefined);


  const value = { item, setItem };

  return <ItemContext.Provider value={value} {...props} />;
}
